var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37848 10H18.6203",
    stroke: "#000000",
    strokeWidth: 1.43333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5677 2.70595V17.2944",
    stroke: "#000000",
    strokeWidth: 1.43333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10342 12.7303C9.83746 11.6347 10.6362 10.6541 11.5248 9.76361",
    stroke: "#000000",
    strokeWidth: 1.43333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49253 2.95108C4.52227 3.04377 3.61774 3.41193 2.92644 3.99552C2.23512 4.5791 1.79782 5.34369 1.68583 6.1646C1.52032 7.41359 1.37964 8.6941 1.37964 10.0015C1.37964 11.3088 1.52032 12.5905 1.68583 13.8383C1.79782 14.6592 2.23512 15.4239 2.92644 16.0074C3.61774 16.591 4.52227 16.9592 5.49253 17.0519C6.95866 17.1849 8.46478 17.297 9.99988 17.297C11.535 17.297 13.0411 17.1849 14.5087 17.0519C15.4789 16.9592 16.3834 16.591 17.0747 16.0074C17.766 15.4239 18.2033 14.6592 18.3154 13.8383C18.4781 12.5893 18.6201 11.3088 18.6201 10.0015C18.6201 8.6941 18.4794 7.41243 18.3139 6.1646C18.202 5.34369 17.7646 4.5791 17.0734 3.99552C16.382 3.41193 15.4774 3.04377 14.5072 2.95108C13.0425 2.81801 11.5363 2.70595 9.99988 2.70595C8.46341 2.70595 6.95866 2.81801 5.49253 2.95108Z",
    stroke: "#000000",
    strokeWidth: 1.43333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7838 9.8013C12.6906 10.7091 16.473 8.19269 14.9327 6.65241C13.3924 5.11213 10.877 8.89354 11.7838 9.8013Z",
    stroke: "#000000",
    strokeWidth: 1.43333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0927 12.7303C13.3586 11.6347 12.5598 10.6541 11.6713 9.76361",
    stroke: "#000000",
    strokeWidth: 1.43333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4122 9.80001C10.5055 10.7078 6.72307 8.19139 8.26335 6.65111C9.80363 5.11083 12.319 8.89224 11.4122 9.80001Z",
    stroke: "#000000",
    strokeWidth: 1.43333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefits);
export default __webpack_public_path__ + "static/media/benefits.f4d4de1c5f06953aa23aeeeb316ce336.svg";
export { ForwardRef as ReactComponent };